/*
 * @Author: zSubmit z236731@163.com
 * @Date: 2022-07-05 15:36:39
 * @LastEditors: zSubmit z236731@163.com
 * @LastEditTime: 2022-07-05 16:51:55
 * @FilePath: \yuetu-web\src\api\survey.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 调查相关的 API
import request from "../util/request";

export function getSurveys(query) {
  return request({
    url: "pr/surveys",
    method: "get",
    params: query,
  });
}

export function getSurvey(id, query) {
  return request({
    url: `pr/surveys/${id}`,
    method: "get",
    params: query,
  });
}

export function createSurvey(data) {
  return request({
    url: "pr/surveys",
    method: "post",
    data,
  });
}

export function updateSurvey(id, data) {
  return request({
    url: `pr/surveys/${id}`,
    method: "put",
    data,
    timeout: 120000,
  });
}

/**
 * 复制一份问卷
 * @param {*} data
 */
export function duplicateSurvey(data) {
  return request({
    url: "pr/surveys/_copy",
    method: "POST",
    data,
  });
}

// 将问卷移入回收站（软删除）
export function softDeleteSurvey(id) {
  return request({
    url: `pr/surveys/${id}`,
    method: "delete",
  });
}

// 查询回收站的问卷列表
export function getRecycleList(query) {
  return request({
    url: "pr/survey-recycle-bin",
    method: "get",
    params: query,
  });
}

// 恢复被移入回收站的问卷
export function restoreSurvey(data) {
  return request({
    url: "pr/survey-recovery",
    method: "put",
    data,
  });
}

// 加速服务
export function vipService(data) {
  return request({
    url: "pr/orders",
    method: "post",
    data,
  });
}

// 文件下载
export function downloadFiles(query) {
  return request({
    url: "pr/shots/_export-doc",
    method: "get",
    params: query,
    timeout: 300000,
  });
}
